var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapaGeoJson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88887 1.4076C8.0173 1.4543 8.1028 1.57637 8.1028 1.71303V9.38988C8.1028 9.61542 7.87869 9.77239 7.66673 9.69531L4.6346 8.59272C4.50616 8.54601 4.42067 8.42395 4.42067 8.28728V0.610438C4.42067 0.3849 4.64477 0.227929 4.85673 0.305005L7.88887 1.4076Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.736328 1.6966C0.736328 1.56817 0.811967 1.45178 0.929333 1.39961L3.29199 0.349544C3.50691 0.254025 3.74898 0.411344 3.74898 0.646533V8.30372C3.74898 8.43215 3.67335 8.54854 3.55598 8.6007L1.19332 9.65077C0.978404 9.74629 0.736328 9.58897 0.736328 9.35378V1.6966Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77357 1.6966C8.77357 1.56817 8.84921 1.45178 8.96658 1.39961L11.3292 0.349544C11.5441 0.254025 11.7862 0.411344 11.7862 0.646533V8.30372C11.7862 8.43215 11.7106 8.54854 11.5932 8.6007L9.23057 9.65077C9.01565 9.74629 8.77357 9.58897 8.77357 9.35378V1.6966Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapaGeoJson);
export default __webpack_public_path__ + "static/media/MapaGeoJSON.bda23310f407aa6e139770b4b487f12a.svg";
export { ForwardRef as ReactComponent };